export default [
  {
    "id": "mat-enem-0473",
    "numero": 1973,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O proprietário de um terreno retangular medindo \n10 m por 31,5 m deseja instalar lâmpadas nos \npontos C e D, conforme ilustrado na figura: \n \n \n \nCada lâmpada ilumina uma região circular de 5 \nm de raio. Os segmentos AC e BD medem 2,5 \nm. O valor em m2 mais aproximado da área do \nterreno iluminada pelas lâmpadas é: \n \n(Aproxime √3 para 1,7 e 𝜋 para 3) \n \n \nA) 34. \nB) 30. \nC) 50. \nD) 69. \nE) 61.",
    "alternativas": {
      "B": "30.",
      "C": "50.",
      "E": "61.",
      "A": "34."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 473,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0474",
    "numero": 1974,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma fábrica possui duas máquinas que produ-\nzem o mesmo tipo de peça. Diariamente a má-\nquina M produz 2000 peças e a máquina N pro-\nduz 3000 peças. Segundo o controle de quali-\ndade da fábrica, sabe-se que 60 peças, das \n2000 produzidas pela máquina M, apresentam \nalgum tipo de defeito, enquanto que 120 peças, \ndas 3000 produzidas pela máquina N, também \napresentam defeitos. Um trabalhador da fábrica \nescolhe ao acaso uma peça, e esta é defeitu-\nosa. \n \nNessas condições, qual a probabilidade de que \na peça defeituosa escolhida tenha sido produzi-\nda pela máquina M? \nA) 3/100 \nB) 1/25 \nC) 1/3 \nD) 3/7 \nE) 2/3",
    "alternativas": {
      "D": "3/7",
      "A": "3/100",
      "B": "1/25",
      "C": "1/3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 474,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0475",
    "numero": 1975,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Nos últimos anos, a frota de veículos no Brasil \ntem crescido de forma acentuada. Observando \no gráfico, é possível verificar a variação do nú-\nmero de veículos (carros, motocicletas e cami-\nnhões), no período de 2000 a 2010. Projeta-se \nque a taxa de crescimento relativo no período \nde 2000 a 2010 mantenha-se para década se-\nguinte. \n \n \n \nQual será o número de veículos no ano de \n2020? \n \nA) 102,0 milhões \nB) 138,0 milhões \nC) 79,2 milhões \nD) 132,0 milhões \nE) 145,2 milhões",
    "alternativas": {
      "E": "145,2 milhões",
      "B": "138,0 milhões",
      "C": "79,2 milhões",
      "D": "132,0 milhões"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 475,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0476",
    "numero": 1976,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Existem hoje, no Brasil, cerca de 2 milhões de \npessoas que sofrem de epilepsia. Há diversos \nmeios de tratamento para a doença, como indi-\ncado no gráfico: \n \n \nConsidere um estado do Brasil, onde 400 000 \npessoas sofrem de epilepsia. Nesse caso, o \nnúmero de pessoas que conseguem se recupe-\nrar com o uso de medicamentos, ou se curar a \npartir da cirurgia para retirada da porção doente \ndo cérebro, é aproximadamente: \n \n \nA) 42000. \nB) 220000. \nC) 340000. \nD) 280000. \nE) 60000.",
    "alternativas": {
      "D": "280000.",
      "E": "60000.",
      "A": "42000.",
      "C": "340000."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 476,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0478",
    "numero": 1978,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O símbolo internacional de acesso, mostrado na \nfigura, anuncia local acessível para o portador \nde necessidades especiais. Na concepção des-\nse símbolo, foram empregados elementos gráfi-\ncos geométricos elementares. \n \n \n \nRegras de acessibilidade ao meio  \nfísico para o deficiente. \n \nOs elementos geométricos que constituem os \ncontornos das partes claras da figura são: \n \nA) coroas circulares e segmentos de retas. \nB) arcos de circunferências e segmentos de \nretas. \nC) arcos de circunferências e retas. \nD) retas e círculos. \nE) retas e circunferências.",
    "alternativas": {
      "C": "arcos de circunferências e retas.",
      "E": "retas e circunferências.",
      "A": "coroas circulares e segmentos de retas.",
      "B": "arcos de circunferências e segmentos de retas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 478,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0479",
    "numero": 1979,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma dona de casa vai ao supermercado fazer a \ncompra mensal. Ao concluir a compra, observa \nque ainda lhe restaram R$ 88,00. Seus gastos \nforam distribuídos conforme mostra o gráfico. As \nporcentagens apresentadas no gráfico são refe-\nrentes ao valor total, em reais, reservado para a \ncompra mensal. \n \n \n \nQual o valor total, em reais, reservado por essa \ndona de casa para a compra mensal? \n \nA) 170,40 \nB) 500,00 \nC) 412,00 \nD) 106,80 \nE) 588,00",
    "alternativas": {
      "B": "500,00",
      "C": "412,00",
      "D": "106,80",
      "A": "170,40"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 479,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0480",
    "numero": 1980,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Em uma casa, há um espaço retangular medin-\ndo 4 m por 6 m, onde se pretende colocar um \npiso de cerâmica resistente e de bom preço. Em \numa loja especializada, há cinco possibilidades \nde pisos que atendem às especificações dese-\njadas, apresentadas no quadro: \n \n \n \nLevando-se em consideração que não há perda \nde material, dentre os pisos apresentados, \naquele que implicará o menor custo para a colo-\ncação no referido espaço é o piso: \n \nA) IV. \nB) I. \nC) V. \nD) II. \nE) III.",
    "alternativas": {
      "C": "V.",
      "D": "II.",
      "E": "III.",
      "B": "I."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 480,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0481",
    "numero": 1981,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Ao realizar uma compra em uma loja de depar-\ntamentos, o cliente tem o direito de participar de \num jogo de dardo, no qual, de acordo com a \nregião do alvo acertada, ele pode ganhar um ou \nmais prêmios. Caso o cliente acerte fora de \ntodos os quatro círculos, ele terá o direito de \nrepetir a jogada, até que acerte uma região que \ndê o direito de ganhar pelo menos um prêmio. O \nalvo é o apresentado na figura: \nAo acertar uma das regiões do alvo, ele terá \ndireito ao(s) prêmio(s) indicado(s) nesta região. \nHá ainda o prêmio extra, caso o cliente acerte o \ndardo no quadrado ABCD. \n \nJoão Maurício fez uma compra nessa loja e teve \no direito de jogar o dardo. A quantidade de prê-\nmios que João Maurício tem a menor probabili-\ndade de ganhar, sabendo que ele jogou o dardo \naleatoriamente, é exatamente: \n \n \nA) 4. \nB) 5. \nC) 3. \nD) 2. \nE) 1.",
    "alternativas": {
      "A": "4.",
      "C": "3.",
      "D": "2.",
      "E": "1."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 481,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0482",
    "numero": 1982,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O tipo mais comum de bebida encontrado nos \nsupermercados não é o suco, mas o néctar de \nfrutas. Os fabricantes de bebida só podem cha-\nmar de suco os produtos que tiverem pelo me-\nnos 50% de polpa, a parte comestível da fruta. \nJá o néctar de frutas é mais doce e tem entre \n20% e 30% de polpa de frutas. \n \nUma pessoa vai ao supermercado e compra \numa caixa de 1 litro de bebida. Em casa ela \npercebe que na embalagem está escrito “néctar \nde frutas com 30% de polpa”.  \nSe essa caixa fosse realmente de suco, neces-\nsitaria de um aumento percentual de polpa de, \naproximadamente, \n \n \nA) 20%. \nB) 167%. \nC) 80%. \nD) 67%. \nE) 200%.",
    "alternativas": {
      "E": "200%.",
      "A": "20%.",
      "B": "167%.",
      "D": "67%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 482,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0483",
    "numero": 1983,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O matemático americano Eduardo Kasner pediu \nao filho que desse um nome a um número muito \ngrande, que consistia do algarismo 1 seguido de \n100 zeros.  \n \nSeu filho batizou o número de gugol. Mais tarde, \no mesmo matemático criou um número que \napelidou de gugolplex, que consistia em 10 ele-\nvado a um gugol. \n \nQuantos algarismos tem um gugolplex? \n \nA) 100 \nB) 10100 + 1 \nC) 101000 + 1 \nD) 101 \nE) 10100",
    "alternativas": {
      "B": "10100 + 1",
      "C": "101000 + 1",
      "E": "10100",
      "A": "100"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 483,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0484",
    "numero": 1984,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma empresa aérea lança uma promoção de final de semana para um voo comercial. Por esse motivo, o \ncliente não pode fazer reservas e as poltronas serão sorteadas aleatoriamente. A figura mostra a posição \ndos assentos no avião: \n \n \n \nPor ter pavor de sentar entre duas pessoas, um passageiro decide que só viajará se a chance de pegar \numa dessas poltronas for inferior a 30%. Avaliando a figura, o passageiro desiste da viagem, porque a \nchance de ele ser sorteado com uma poltrona entre duas pessoas é mais aproximada de: \n \n \nA) 68%. \nB) 69%. \nC) 35%. \nD) 31%. \nE) 33%.",
    "alternativas": {
      "A": "68%.",
      "B": "69%.",
      "C": "35%.",
      "D": "31%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 484,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0485",
    "numero": 1985,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Para um principiante em corrida, foi estipulado o \nseguinte plano de treinamento diário: correr 300 \nmetros no primeiro dia e aumentar 200 metros \npor dia, a partir do segundo. Para contabilizar \nseu rendimento, ele utilizará um chip, preso ao \nseu tênis, para medir a distância percorrida nos \ntreinos. Considere que esse chip armazene, em \nsua memória, no máximo 9,5 km de corri-\nda/caminhada, devendo ser colocado no mo-\nmento do início do treino e descartado após \nesgotar o espaço para reserva de dados. \n \nSe esse atleta utilizar o chip desde o primeiro \ndia de treinamento, por quantos dias consecuti-\nvos esse chip poderá armazenar a quilometra-\ngem desse plano de treino diário? \n \nA) 8 \nB) 9 \nC) 7 \nD) 13 \nE) 12",
    "alternativas": {
      "A": "8",
      "C": "7",
      "D": "13",
      "E": "12"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 485,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0486",
    "numero": 1986,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O Conselho Monetário Nacional (CMN) determi-\nnou novas regras sobre o pagamento mínimo da \nfatura do cartão de crédito, a partir do mês de \nagosto de 2011. A partir de então, o pagamento \nmensal não poderá ser inferior a 15% do valor \ntotal da fatura. Em dezembro daquele ano, outra \nalteração foi efetuada: daí em diante, o valor \nmínimo a ser pago seria de 20% da fatura. \n \nUm determinado consumidor possuía no dia do \nvencimento, \n01/03/2012, \numa \ndívida \nde \nR$1000,00 na fatura de seu cartão de crédito. \nSe não houver pagamento do valor total da fatu-\nra, são cobrados juros de 10% sobre o saldo \ndevedor para a próxima fatura. Para quitar sua \ndívida, optou por pagar sempre o mínimo da \nfatura a cada mês e não efetuar mais nenhuma \ncompra. \n \nA dívida desse consumidor em 01/05/2012 será \nde: \n \nA) R$ 874,22. \nB) R$ 722,50. \nC) R$ 774,40. \nD) R$ 600,00. \nE) R$ 640,00.",
    "alternativas": {
      "A": "R$ 874,22.",
      "C": "R$ 774,40.",
      "D": "R$ 600,00.",
      "E": "R$ 640,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 486,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0487",
    "numero": 1987,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Em um folheto de propaganda foi desenhada \numa planta de um apartamento medindo 6 m × \n8 m, na escala 1 : 50. Porém, como sobrou mui-\nto espaço na folha, foi decidido aumentar o de-\nsenho da planta, passando para a escala 1 : 40. \nApós essa modificação, quanto aumentou, em \ncm2, a área do desenho da planta? \n \nA) 0,0108 \nB) 108 \nC) 191,88 \nD) 300 \nE) 43200",
    "alternativas": {
      "B": "108",
      "D": "300",
      "E": "43200",
      "A": "0,0108"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 487,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0488",
    "numero": 1988,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O proprietário de uma casa de espetáculos ob-\nservou que, colocando o valor da entrada a \nR$10,00, sempre contava com 1000 pessoas a \ncada apresentação, faturando R$ 10000,00 com \na venda dos ingressos. Entretanto, percebeu \ntambém que, a partir de R$10,00, a cada \nR$2,00 que ele aumentava no valor da entrada, \nrecebia para os espetáculos 40 pessoas a me-\nnos. \n \nNessas condições, considerando P o número de \npessoas presentes em um determinado dia e F \no faturamento com a venda dos ingressos, a \nexpressão que relaciona o faturamento em fun-\nção do número de pessoas é dada por: \n \nA) F = \n−P2\n20  + 60P \n \nB) F = \nP2\n20 + 60P \n \nC) F = −P2 + 1200P \n \nD) F = \n−P2\n20  + 60 \n \nE) F = P2 + 1200P",
    "alternativas": {
      "E": "F = P2 + 1200P",
      "A": "F = −P2 20 + 60P",
      "B": "F = P2 20 + 60P",
      "C": "F = −P2 + 1200P"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 488,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0489",
    "numero": 1989,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma dona de casa faz um comparativo de cus-\ntos para decidir se irá adquirir uma máquina \nlavadora de louças para substituir a lavagem \nmanual. Decide calcular o custo com a lavagem \nde louças por um período de 30 dias, com duas \nlavagens por dia. Ela constatou que não precisa \nconsiderar os custos do detergente e do sabão, \npois, na máquina lavadora e na lavagem manu-\nal, são equivalentes. Verificou que gasta em \nmédia 90 litros de água em cada lavagem ma-\nnual.  \n \nCada lavagem na máquina gasta 16 litros de \nágua e 0,9 kWh de energia. Sabe-se que a \ncompanhia de distribuição de água cobra R$ \n6,25 por metro cúbico (pelo consumo de água e \ndispersão e tratamento de esgoto) e a compa-\nnhia elétrica cobra R$ 0,45 por kWh consumido. \nDe acordo com essas informações, num período \nde 30 dias, a lavagem manual ficará mais cara \nque a da máquina lavadora em quantos reais? \n \nA) 27,75 \n \nB) 4,72  \nC) 9,45  \nD) 3,45 \nE) 1,72",
    "alternativas": {
      "B": "4,72",
      "C": "9,45",
      "D": "3,45",
      "A": "27,75"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 489,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0490",
    "numero": 1990,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "A tabela apresenta os registros de ocorrência de \nacidentes de trabalho por categorias econômi-\ncas no Brasil, no mês de julho de 2001: \n \n \n \nConsiderando os dados dispostos na tabela, \numa pessoa que pretende ingressar no mercado \nde trabalho decide pela ocupação de menor \ngrau de risco de acidente de trabalho. Sabendo \nque o grau de risco é a probabilidade de ocor-\nrência de acidentes de trabalho em categorias \nde atividade econômica, sua opção é se empre-\ngar na atividade econômica: \n \nA) administração pública, pois representa risco \naproximado de acidente de trabalho igual a \n0,18%. \nB) crédito, pois apresenta o menor registro de \nquantidade de empregados. \nC) crédito, pois representa risco aproximado de \nacidente de trabalho igual a 1,15%. \nD) crédito, pois representa risco aproximado de \nacidente de trabalho igual a 2,58%. \nE) administração pública, pois apresenta o me-\nnor registro de afastamento por acidente de \ntrabalho.",
    "alternativas": {
      "C": "crédito, pois representa risco aproximado de acidente de trabalho igual a 1,15%.",
      "D": "crédito, pois representa risco aproximado de acidente de trabalho igual a 2,58%.",
      "E": "administração pública, pois apresenta o me- nor registro de afastamento por acidente de trabalho.",
      "A": "administração pública, pois representa risco aproximado de acidente de trabalho igual a 0,18%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 490,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0491",
    "numero": 1991,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Em um experimento, uma cultura de bactérias \ntem sua população reduzida pela metade a ca-\nda hora, devido à ação de um agente bacterici-\nda. \nNeste experimento, o número de bactérias em \nfunção do tempo pode ser modelado por uma \nfunção do tipo: \n \n \nA) seno. \nB) afim. \nC) logarítmica crescente. \nD) cosseno. \nE) exponencial.",
    "alternativas": {
      "E": "exponencial.",
      "A": "seno.",
      "C": "logarítmica crescente.",
      "D": "cosseno."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 491,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0492",
    "numero": 1992,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma fábrica de brinquedos educativos vende \numa caixa com fichas pretas e fichas brancas \npara compor sequências de figuras seguindo \npadrões. Na caixa, a orientação para represen-\ntar as primeiras figuras da sequência de barcos \né acompanhada deste desenho: \n \n \n \nQual é o total de fichas necessárias para formar \na 15ª figura da sequência? \n \n \nA) 120 \nB) 360 \nC) 240 \nD) 87 \nE) 45",
    "alternativas": {
      "D": "87",
      "E": "45",
      "A": "120",
      "B": "360"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 492,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0493",
    "numero": 1993,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma característica interessante do som é sua \nfrequência. Quando uma fonte sonora se apro-\nxima do ouvinte, o som ouvido por ele tem uma \nfrequência maior do que o som produzido pela \nmesma fonte sonora, se ela estiver parada. \nEntretanto, se a fonte sonora se afasta do ou-\nvinte, a frequência é menor. Esse fenômeno é \nconhecido como efeito Doppler. \n \nUm ouvinte parado junto a uma fonte ouve o \nseu som com uma frequência constante, que \nserá denotada por ƒ. Quatro experimentos fo-\nram feitos com essa fonte sonora em movimen- \nto. Denotaremos por ƒ1, ƒ2, ƒ3 e ƒ4 as frequên-\ncias do som da fonte sonora em movimento \nouvido pelo ouvinte, que continua parado, nos \nexperimentos 1, 2, 3 e 4, respectivamente. \n \nDepois de calculadas as frequências, as seguin-\ntes relações foram obtidas: \n \nƒ1 = 1,1ƒ, ƒ2 = 0,99ƒ1, ƒ1 = 0,9ƒ3 e ƒ4= 0,9ƒ \n \nEm quais experimentos a fonte sonora se afas-\ntou do ouvinte? \n \n \nA) Somente nos experimentos 2, 3 e 4. \nB) Somente nos experimentos 2 e 4. \nC) Somente nos experimentos 1, 2 e 3. \nD) Somente no experimento 4. \nE) Somente nos experimentos 3 e 4.",
    "alternativas": {
      "B": "Somente nos experimentos 2 e 4.",
      "C": "Somente nos experimentos 1, 2 e 3.",
      "D": "Somente no experimento 4.",
      "A": "Somente nos experimentos 2, 3 e 4."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 493,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0494",
    "numero": 1994,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Um trabalhador possui um cartão de crédito \nque, em determinado mês, apresenta o saldo \ndevedor a pagar no vencimento do cartão, mas \nnão contém parcelamentos a acrescentar em \nfuturas faturas. Nesse mesmo mês, o trabalha-\ndor é demitido. Durante o período de desem-\nprego, o trabalhador deixa de utilizar o cartão de \ncrédito e também não tem como pagar as fatu-\nras, nem a atual nem as próximas, mesmo sa-\nbendo que, a cada mês, incidirão taxas de juros \ne encargos por conta do não pagamento da \ndívida. Ao conseguir um novo emprego, já com-\npletados 6 meses de não pagamento das fatu-\nras, o trabalhador procura renegociar sua dívi-\nda. O gráfico mostra a evolução do saldo deve-\ndor. \n \n \nCom base no gráfico, podemos constatar que o \nsaldo devedor inicial, a parcela mensal de juros \ne a taxa de juros são: \nA) R$ 500,00; variável e superior a 10% ao mês. \nB) R$ 560,00; constante e superior a 10% ao \nmês. \nC) R$ 500,00; variável e inferior a 10% ao mês. \nD) R$ 560,00; variável e inferior a 10% ao mês. \nE) R$ 500,00; constante e inferior a 10% ao \nmês.",
    "alternativas": {
      "B": "R$ 560,00; constante e superior a 10% ao mês.",
      "C": "R$ 500,00; variável e inferior a 10% ao mês.",
      "D": "R$ 560,00; variável e inferior a 10% ao mês.",
      "A": "R$ 500,00; variável e superior a 10% ao mês."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 494,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0495",
    "numero": 1995,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "A estimativa do número de indivíduos de uma \npopulação de animais frequentemente envolve a \ncaptura, a marcação e, então, a liberação de \nalguns desses indivíduos. Depois de um perío-\ndo, após os indivíduos marcados se misturarem \ncom os não marcados, realiza-se outra amos-\ntragem. A proporção de indivíduos desta segun-\nda amostragem que já estava marcada pode ser \nutilizada para estimar o tamanho da população, \naplicando-se a fórmula: \n \nm2\nn2 = \nn1\nM \n \nOnde: \n \n• n1= número de indivíduos marcados na primei-\nra amostragem; \n• n2= número de indivíduos marcados na segun-\nda amostragem; \n• m2= número de indivíduos da segunda amos-\ntragem que foram marcados na primeira amos-\ntragem; \n• N= tamanho estimado da população total. \n \nDurante uma contagem de indivíduos de uma \npopulação, na primeira amostragem foram mar-\ncados 120; na segunda amostragem foram mar-\ncados 150, dos quais 100 já possuíam a marca-\nção. O número estimado de indivíduos dessa \npopulação é: \n \n \nA) 96. \nB) 180. \nC) 188. \nD) 125. \nE) 80.",
    "alternativas": {
      "D": "125.",
      "E": "80.",
      "B": "180.",
      "C": "188."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 495,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0496",
    "numero": 1996,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "O gráfico a seguir apresenta as taxas de de-\nsemprego durante o ano de 2011 e o primeiro \nsemestre de 2012 na região metropolitana de \nSão Paulo. A taxa de desemprego total é a so-\nma das taxas de desemprego aberto e oculto. \n \nSuponha que a taxa de desemprego oculto do \nmês de dezembro de 2012 tenha sido a metade \nda mesma taxa em junho de 2012 e que a taxa \nde desemprego total em dezembro de 2012 seja \nigual a essa taxa em dezembro de 2011. \n \n \nNesse caso, a taxa de desemprego aberto de \ndezembro de 2012 teria sido, em termos per-\ncentuais, de: \n \nA) 1,1. \nB) 3,5. \nC) 4,5. \nD) 6,8. \nE) 7,9.",
    "alternativas": {
      "A": "1,1.",
      "C": "4,5.",
      "D": "6,8.",
      "E": "7,9."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 496,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0497",
    "numero": 1997,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "A taxa de fecundidade é um indicador que ex-\npressa a condição reprodutiva média das mu-\nlheres de uma região, e é importante para uma \nanálise da dinâmica demográfica dessa região. \nA tabela apresenta os dados obtidos pelos Cen-\nsos de 2000 e 2010, feitos pelo IBGE, com rela-\nção à taxa de fecundidade no Brasil. \n \n \n \nSuponha que a variação percentual relativa na \ntaxa de fecundidade no período de 2000 a 2010 \nse repita no período de 2010 a 2020. \nNesse caso, em 2020 a taxa de fecundidade no \nBrasil estará mais próxima de: \n \nA) 1,14. \nB) 1,42. \nC) 1,52. \nD) 1,70. \nE) 1,80.",
    "alternativas": {
      "C": "1,52.",
      "E": "1,80.",
      "A": "1,14.",
      "B": "1,42."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 497,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0498",
    "numero": 1998,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "O Ministério da Saúde e as unidades federadas \npromovem frequentemente campanhas nacio-\nnais e locais de incentivo à doação voluntária de \nsangue, em regiões com menos número de \ndoadores por habitante, com o intuito de manter \na regularidade de estoques nos serviços hemo-\nterápicos. Em 2010, foram recolhidos dados \nsobre o número de doadores e o número de \nhabitantes de cada região conforme o quadro \nseguinte. \n \n \nOs resultados obtidos permitiram que estados, \nmunicípios e o governo federal estabelecessem \nas regiões prioritárias do país para a intensifica-\nção das campanhas de doação de sangue. A \ncampanha deveria ser intensificada nas regiões \nem que o percentual de doadores por habitantes \nfosse menor ou igual ao do país. \n \nAs regiões brasileiras onde foram intensificadas \nas campanhas na época são: \n \nA) Norte, Centro-Oeste e Sul. \nB) Norte, Nordeste e Sudeste. \nC) Nordeste, Norte e Sul. \nD) Nordeste, Sudeste e Sul. \nE) Centro-Oeste, Sul e Sudeste.",
    "alternativas": {
      "A": "Norte, Centro-Oeste e Sul.",
      "B": "Norte, Nordeste e Sudeste.",
      "C": "Nordeste, Norte e Sul.",
      "E": "Centro-Oeste, Sul e Sudeste."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 498,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0499",
    "numero": 1999,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um carpinteiro fabrica portas retangulares maci-\nças, feitas de um mesmo material. Por ter rece-\nbido de seus clientes pedidos de portas mais \naltas, aumentou sua altura em 1/8, preservando \nsuas espessuras. A fim de manter o custo com \no material de cada porta, precisou reduzir a \nlargura. \n \nA razão entre a largura da nova porta e a largu-\nra da porta anterior é: \n \nA) 1/8 \nB) 7/8 \nC) 8/7 \nD) 8/9 \nE) 9/8",
    "alternativas": {
      "D": "8/9",
      "A": "1/8",
      "B": "7/8",
      "C": "8/7"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 499,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0500",
    "numero": 2000,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "De acordo com a ONU, da água utilizada diari-\namente, \n \n• 25% são para tomar banho, lavar as mãos e \nescovar os dentes. \n• 33% são utilizados em descarga de banheiro. \n• 27% são para cozinhar e beber. \n• 15% são para demais atividades. \n \nNo Brasil, o consumo de água por pessoa che-\nga, em média, a 200 litros por dia. O quadro \nmostra sugestões de consumo moderado de \nágua por pessoa, em algumas atividades. \n \n \nSe cada brasileiro adotar o consumo de água \nindicado no quadro, mantendo o mesmo con-\nsumo nas demais atividades, então economiza-\nrá diariamente, em média, em litros de água, \n \nA) 30,0. \nB) 69,6. \nC) 100,4. \nD) 130,4. \nE) 170,0.",
    "alternativas": {
      "D": "130,4.",
      "E": "170,0.",
      "B": "69,6.",
      "C": "100,4."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 500,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0501",
    "numero": 2001,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Os candidatos K, L, M, N e P estão disputando \numa única vaga de emprego em uma empresa e \nfizeram provas de português, matemática, direi-\nto e informática. A tabela apresenta as notas \nobtidas pelos cinco candidatos. \n \n \n \nSegundo o edital de seleção, o candidato apro-\nvado será aquele para o qual a mediana das \nnotas obtidas por ele nas quatro disciplinas for a \nmaior. \n \nO candidato aprovado será: \n \nA) K. \nB) L. \nC) M. \nD) N. \nE) P.",
    "alternativas": {
      "D": "N.",
      "E": "P.",
      "A": "K.",
      "C": "M."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 501,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0502",
    "numero": 2002,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Na alimentação de gado de corte, o processo de \ncortar a forragem, colocá-la no solo, compactá-\nla e protegê-la com uma vedação denomina-se \nsilagem. Os silos mais comuns são os horizon-\ntais, cuja forma é a de um prisma trapezoidal, \nconforme mostrado na figura. \n \n \nConsidere um silo de 2 m de altura, 6 m de lar-\ngura de topo e 20 m de comprimento. Para cada \nmetro de altura do silo, a largura do topo tem \n0,5 m a mais do que a largura do fundo. Após a \nsilagem, 1 tonelada de forragem ocupa 2 m3 \ndesse tipo de silo. \n \nApós a silagem, a quantidade máxima de forra-\ngem que cabe no silo, em toneladas, é: \n \nA) 110. \nB) 125. \nC) 130. \nD) 220. \nE) 260.",
    "alternativas": {
      "B": "125.",
      "D": "220.",
      "E": "260.",
      "A": "110."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 502,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0505",
    "numero": 2005,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um professor, depois de corrigir as provas de \nsua turma, percebeu que várias questões esta-\nvam muito difíceis. Para compensar, decidiu \nutilizar uma função polinomial f, de grau menor \nque 3, para alterar as notas x da prova para \nnotas y = f(x), da seguinte maneira: \n \n• a nota zero permanece zero. \n• a nota 10 permanece 10. \n• a nota 5 passa a ser 6. \n \nA expressão da função y=f(x) a ser utilizada \npelo professor é: \n \nA) y = - \n1\n25x2 + \n7\n5x \n \nB) y = - \n1\n10x2 + 2x \n \nC) y = \n1\n24x2 + \n7\n12x \n \nD) y = \n4\n5x + 2 \n \nE) y = x",
    "alternativas": {
      "A": "y = - 1 25x2 + 7 5x",
      "C": "y = 1 24x2 + 7 12x",
      "D": "y = 4 5x + 2",
      "E": "y = x"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 505,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0506",
    "numero": 2006,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Durante a Segunda Guerra Mundial, para deci-\nfrarem as mensagens secretas, foi utilizada a \ntécnica de decomposição em fatores primos.  \n \nUm número N é dado pela expressão 2x⋅5y⋅7z, \nna qual x, y e z são números inteiros não nega-\ntivos. Sabe-se que N é múltiplo de 10 e não é \nmúltiplo de 7. \n \nO número de divisores de N, diferentes de N, é: \nA) x⋅y⋅z \nB) (x+1)⋅(y+1) \nC) x⋅y⋅z−1 \nD) (x+1)⋅(y−1)⋅z \nE) (x+1)⋅(y+1)⋅(z+1)−1",
    "alternativas": {
      "D": "(x+1)⋅(y−1)⋅z",
      "E": "(x+1)⋅(y+1)⋅(z+1)−1",
      "A": "x⋅y⋅z",
      "C": "x⋅y⋅z−1"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 506,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0507",
    "numero": 2007,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma criança deseja criar triângulos utilizando \npalitos de fósforo de mesmo comprimento. Cada \ntriângulo será construído com exatamente 17 \npalitos e pelo menos um dos lados do triângulo \ndeve ter o comprimento de exatamente 6 pali-\ntos. A figura ilustra um triângulo construído com \nessas características. \n \n \n \nA quantidade máxima de triângulos não congru-\nentes dois a dois que podem ser construídos é: \n \nA) 3. \nB) 5. \nC) 6. \nD) 8. \nE) 10.",
    "alternativas": {
      "D": "8.",
      "E": "10.",
      "A": "3.",
      "B": "5."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 507,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0508",
    "numero": 2008,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "A figura mostra uma criança brincando em um \nbalanço no parque. A corda que prende o as-\nsento do balanço ao topo do suporte mede 2 \nmetros. A criança toma cuidado para não sofrer \num acidente, então se balança de modo que a \ncorda não chegue a alcançar a posição horizon-\ntal. \n \nNa figura, considere o plano cartesiano que \ncontém a trajetória do assento do balanço, no \nqual a origem está localizada no topo do suporte \ndo balanço, o eixo X é o paralelo ao chão do \nparque, e o eixo Y tem orientação positiva para \ncima. A curva determinada pela trajetória do \nassento do balanço é parte do gráfico da fun-\nção: \n \nA) f(x) = − √2 −x2 \nB) f(x) = √2 −x2 \nC) f(x) = x2 − 2 \nD) f(x) = − √4 −x2 \nE) f(x) = √4 −x2",
    "alternativas": {
      "A": "f(x) = − √2 −x2",
      "B": "f(x) = √2 −x2",
      "C": "f(x) = x2 − 2",
      "D": "f(x) = − √4 −x2"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 508,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0509",
    "numero": 2009,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um show especial de Natal teve 45000 ingres-\nsos vendidos. Esse evento ocorrerá em um \nestádio de futebol que disponibilizará 5 portões \nde entrada, com 4 catracas eletrônicas por por-\ntão. Em cada uma dessas catracas, passará \numa única pessoa a cada 2 segundos. O públi-\nco foi igualmente dividido pela quantidade de \nportões e catracas, indicados no ingresso para o \nshow, para a efetiva entrada no estádio. Supo-\nnha que todos aqueles que compraram ingres-\nsos irão ao show e que todos passarão pelos \nportões e catracas eletrônicas indicados. Qual é \no tempo mínimo para que todos passem pelas \ncatracas? \n \nA) 1 hora. \nB) 1 hora e 15 minutos. \nC) 5 horas. \nD) 6 horas. \nE) 6 horas e 15 minutos.",
    "alternativas": {
      "D": "6 horas.",
      "A": "1 hora.",
      "B": "1 hora e 15 minutos.",
      "C": "5 horas."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 509,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0510",
    "numero": 2010,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Conforme regulamento da Agência Nacional de \nAviação Civil (Anac), o passageiro que embar-\ncar em voo doméstico poderá transportar baga-\ngem de mão, contudo a soma das dimensões \nda bagagem (altura + comprimento + largura) \nnão pode ser superior a 115 cm. A figura mostra \na planificação de uma caixa que tem a forma de \num paralelepípedo retângulo. \nO maior valor possível para x, em centímetros, \npara que a caixa permaneça dentro dos padrões \npermitidos pela Anac é: \n \nA) 25.  \nB) 33. \nC) 42. \nD) 45. \nE) 49.",
    "alternativas": {
      "D": "45.",
      "E": "49.",
      "B": "33.",
      "C": "42."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 510,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0511",
    "numero": 2011,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma lata de tinta, com a forma de um paralele-\npípedo retangular reto, tem as dimensões, em \ncentímetros, mostradas na figura. \n \n \n \nSerá produzida uma nova lata, com os mesmos \nformato e volume, de tal modo que as dimen-\nsões de sua base sejam 25% maiores que as da \nlata atual. \n \nPara obter a altura da nova lata, a altura da lata \natual deve ser reduzida em: \n \nA) 14,4% \nB) 20,0% \nC) 32,0% \nD) 36,0% \nE) 64,0%",
    "alternativas": {
      "A": "14,4%",
      "C": "32,0%",
      "D": "36,0%",
      "E": "64,0%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 511,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0512",
    "numero": 2012,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma organização não governamental divulgou \num levantamento de dados realizado em algu-\nmas cidades brasileiras sobre saneamento bá-\nsico. Os resultados indicam que somente 36% \ndo esgoto gerado nessas cidades é tratado, o \nque mostra que 8 bilhões de litros de esgoto \nsem nenhum tratamento são lançados todos os \ndias nas águas. \n \nUma campanha para melhorar o saneamento \nbásico nessas cidades tem como meta a redu-\nção da quantidade de esgoto lançado nas águas \ndiariamente, sem tratamento, para 4 bilhões de \nlitros nos próximos meses.  \n \nSe o volume de esgoto gerado permanecer o \nmesmo e a meta dessa campanha se concreti-\nzar, o percentual de esgoto tratado passará a \nser: \nA) 72% \nB) 68% \nC) 64% \nD) 54% \nE) 18%",
    "alternativas": {
      "D": "54%",
      "E": "18%",
      "A": "72%",
      "B": "68%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 512,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0513",
    "numero": 2013,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma empresa de alimentos oferece três valores \ndiferentes de remuneração a seus funcionários, \nde acordo com o grau de instrução necessário \npara cada cargo. No ano de 2013, a empresa \nteve uma receita de 10 milhões de reais por \nmês e um gasto mensal com a folha salarial de \nR$ 400.000,00, distribuídos de acordo com o \nGráfico 1. No ano seguinte, a empresa ampliará \no número de funcionários, mantendo o mesmo \nvalor salarial para cada categoria. Os demais \ncustos da empresa permanecerão constantes \nde 2013 para 2014. O número de funcionários \nem 2013 e 2014, por grau de instrução, está no \nGráfico 2. \n \nDistribuição da folha salarial \n \n \nNúmero de funcionários por  \ngrau de instrução \n \n \nQual deve ser o aumento na receita da empresa \npara que o lucro mensal em 2014 seja o mesmo \nde 2013? \n \nA) R$ 114.285,00 \nB) R$ 130.000,00 \nC) R$ 160.000,00 \nD) R$ 210.000,00 \nE) R$ 213.333,00",
    "alternativas": {
      "E": "R$ 213.333,00",
      "A": "R$ 114.285,00",
      "B": "R$ 130.000,00",
      "C": "R$ 160.000,00"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 513,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0514",
    "numero": 2014,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Boliche é um jogo em que se arremessa uma \nbola sobre uma pista para atingir dez pinos, \ndispostos em uma formação de base triangular, \nbuscando derrubar o maior número de pinos. A \nrazão entre o total de vezes em que o jogador \nderruba todos os pinos e o número de jogadas \ndetermina seu desempenho. \n \nEm uma disputa entre cinco jogadores, foram \nobtidos os seguintes resultados: \n \nJogador I - Derrubou todos os pinos 50 vezes \nem 85 jogadas. \n \nJogador II - Derrubou todos os pinos 40 vezes \nem 65 jogadas. \n \nJogador III - Derrubou todos os pinos 20 vezes \nem 65 jogadas. \n \nJogador IV - Derrubou todos os pinos 30 vezes \nem 40 jogadas. \n \nJogador V - Derrubou todos os pinos 48 vezes \nem 90 jogadas. \n \nQual desses jogadores apresentou maior de-\nsempenho? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "D": "IV",
      "A": "I",
      "B": "II"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 514,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0515",
    "numero": 2015,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Ao final de uma competição de ciências em uma \nescola, restaram apenas três candidatos. De \nacordo com as regras, o vencedor será o candi-\ndato que obtiver a maior média ponderada entre \nas notas das provas finais nas disciplinas quími-\nca e física, considerando, respectivamente, os \npesos 4 e 6 para elas. As notas são sempre \nnúmeros inteiros. Por questões médicas, o can-\ndidato II ainda não fez a prova final de química. \nNo dia em que sua avaliação for aplicada, as \nnotas dos outros dois candidatos em ambas as \ndisciplinas, já terão sido divulgadas. \n \nO quadro apresenta as notas obtidas pelos fina-\nlistas nas provas finais. \n \n \n \nA menor nota que o candidato II deverá obter na \naprova final de química para vencer a competi-\nção é: \nA) 18. \nB) 19. \nC) 22. \nD) 25. \nE) 26.",
    "alternativas": {
      "D": "25.",
      "E": "26.",
      "A": "18.",
      "C": "22."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 515,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];